export default __webpack_public_path__ + "static/media/222.bd620084.png";